import type { KeyedMutator } from 'swr'
import useSWR from 'swr'
import type { DomainAssetsInterface } from '../types/domain'
import { useApiWrapperWithErrorValidation } from './use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from './use-api-wrapper-with-error-validation/types'
import useUser from './use-user'

export const DOMAIN_ASSETS_API = '/api/domain/assets'

interface UseDomainAssetsResult {
  domainAssets: DomainAssetsInterface | undefined
  mutate: KeyedMutator<DomainAssetsInterface>
  isValidating: boolean
}

export default function useDomainAssets(): UseDomainAssetsResult {
  const { user } = useUser()
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    DomainAssetsInterface
  >({ method: RequestMethodsEnum.get })

  const {
    data: domainAssets,
    mutate,
    isValidating,
  } = useSWR<DomainAssetsInterface>(() => user && DOMAIN_ASSETS_API, fetcher)

  return { domainAssets, mutate, isValidating }
}
